import Activity from './_deprecated/Activity';
import { MGActivityProgress } from './MGActivity';

export enum AssignmentType {
  TEXT = 'TEXT',
  NOTHING = 'NOTHING',
}

export default interface HomeworkActivity {
  id: number;
  activity: Activity;
  content: string;
  assignmentType: AssignmentType;
  isActive: boolean;
}

export interface HomeworkActivityProgress {
  id: number;
  homework: HomeworkActivity;
  answer: string | null;
  status: HomeworkActivityProgressStatus | null;
  createdAt: string;
  isDone: boolean;
  activityProgress: MGActivityProgress;
  studentId: number;
}

export enum HomeworkActivityProgressStatus {
  SENT = 'SENT',
  GRADED = 'GRADED',
  DISAPPROVED = 'DISAPPROVED',
}
